import React, { useState } from "react";

const AutoFill = ({setAutoFill, autoFill, setQueryString, setSearchResults, setFeaturedResults}) => {
  
  return (
    autoFill.records.map((result, idx) => {
        return (
          <a href='#' key={idx}>
          <li key={ result.id } onClick={async _ => {
            try{
              setSearchResults(autoFill);
              setFeaturedResults(result)
            }
              catch(error){
              console.error(error);
            }
            finally{
              setAutoFill({ info : {}, records : [],});
              setQueryString('');
            }
          }}>  
            { result.title }
          </li>
        </a>
        )
      })
  )
}

export default AutoFill;